// extracted by mini-css-extract-plugin
module.exports = {"ctaContainer":"Cta_ctaContainer__iEV5m","ctaTitle":"Cta_ctaTitle__Xdatd","fadeIn":"Cta_fadeIn__dpJDC"};